import React from 'react';
import { Eye } from 'lucide-react';
import RobbieMark from './RobbieMark';

/**
 * The slim bar at the top of an RFQ someone else created. Robbie says whose it
 * is and what the viewer can still do — the honest counterpart to the controls
 * the rest of the wizard leaves out. Naming the owner costs nothing: the RFQ
 * carries the creator's name; when it doesn't, the bar says view-only without
 * inventing one.
 */
export interface ViewOnlyBannerProps {
  /** The RFQ's creator, when the record knows the name. */
  ownerName?: string | null;
  className?: string;
}

export const ViewOnlyBanner: React.FC<ViewOnlyBannerProps> = ({ ownerName, className = '' }) => (
  <div
    role="status"
    className={`flex items-center gap-s4 rounded-card border border-robbie-border bg-ai-panel px-[14px] py-[10px] ${className}`}
  >
    <RobbieMark size="xs" aria-label="Robbie" />
    <p className="m-0 min-w-0 text-body-sm text-ink-body">
      {ownerName
        ? `This is ${ownerName}'s RFQ — you're viewing it. Everything's here to read and download; ask ${ownerName} for any changes.`
        : "This RFQ belongs to someone else on your team — you're viewing it. Everything's here to read and download; ask them for any changes."}
    </p>
    <span className="ml-auto inline-flex shrink-0 items-center gap-s2 rounded-round border border-line-strong bg-surface px-s4 py-[2px] text-meta font-semibold text-ink-secondary">
      <Eye className="h-[11px] w-[11px]" />
      View only
    </span>
  </div>
);

export default ViewOnlyBanner;
